module.exports = __webpack_public_path__ + "media/images/payments/okpay-5df257442bbabb043b75ac6db9a0a76c.svg";